<template>
  <div
    v-if="showDelayedLoading"
    class="loading-spinner-page"
  >
    <LoadingSpinner />
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeUnmount, watch } from 'vue';
import LoadingSpinner from '~/components/loading-spinner.vue';
import { isLoading } from '~/composables/use-loading';

const showDelayedLoading = ref(false);
const delayTimeout = ref<number | null>(null);

watch(isLoading, (state) => {
  if (delayTimeout.value) {
    clearTimeout(delayTimeout.value);
  }
  if (!state) {
    showDelayedLoading.value = false;
    return;
  }
  delayTimeout.value = setTimeout(() => {
    showDelayedLoading.value = true;
  }, 100);
});

onBeforeUnmount(() => {
  if (delayTimeout.value) {
    clearTimeout(delayTimeout.value);
  }
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.loading-spinner-page {
  background-color: rgba(color(white), 0.5);
  display: flex;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: $z-index-loader;
  pointer-events: auto;
  justify-content: center;
  align-items: center;
}
</style>
